<app-vcr-classroom *ngIf="!classroomInitService.isLoading; else loaderPage"></app-vcr-classroom>
<ng-template #loaderPage>
  <app-loader></app-loader>
</ng-template>
